//@flow
import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin360 = keyframes`
  to {
    transform: rotate(1turn);
  }
`
const Spinner = styled.img`
  width: 85px;
  height: 85px;
  animation: ${spin360} 1s infinite steps(8);
`

/**
 * Default loading component.
 * @memberof components
 */
export default (props: *) => <Spinner src="/img/spinner.png" {...props} />



// WEBPACK FOOTER //
// ./src/components/Spinner.js